<div class="d-flex font-weight-bold w-100 pb-2 text-primary">
  {{'DATA_STUDIO.DATA_PARAMETERS.AVAILABLE_SIGNALS' | translate}}
</div>
<div class="border rounded w-100 mb-3 text-primary">
  <mat-accordion>
    <mat-expansion-panel expanded>
      <mat-expansion-panel-header class="p-2">
        <mat-panel-title>
          <div class="d-flex justify-content-between align-items-center w-100">
            <mat-checkbox [checked]="allSignalsSelected" (change)="selectAllMetmasts($event)" (click)="$event.stopPropagation()">
              <span><b>{{'DATA_STUDIO.SIGNALS.ALL_SIGNALS' | translate}}</b></span>
            </mat-checkbox>
            <span><small>
              {{totalSignalsSelected}} {{'COMMON.OF' | translate}} {{totalSignals}}
            </small></span>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        @for (metmast of metmastsList; track $index; let i = $index) {
          <div class="w-100 border-top">
            <mat-accordion>
              <mat-expansion-panel expanded>
                <mat-expansion-panel-header class="px-3 py-2">
                  <mat-panel-title>
                    <div class="d-flex justify-content-between align-items-center w-100">
                      <mat-checkbox [checked]="metmast.checked" (change)="selectMetmast($event, metmast)" (click)="$event.stopPropagation()">
                        <span class="font-weight-bold">{{ metmast.name }}
                        </span>
                      </mat-checkbox>
                      <span>
                        <small>
                          {{metmast.totalSelected}} {{'COMMON.OF' | translate}} {{metmast.total}}
                        </small>
                      </span>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                  @for (sensor of metmast.sensorsList; track $index;) {
                    <div class="w-100 border-top px-4">
                      <div class="d-flex justify-content-between w-100 py-2">
                        <mat-checkbox [checked]="sensor.checked" (change)="selectSensor($event, sensor, metmast)">
                          <span class="font-weight-bold">{{sensor.name }}
                          </span>
                        </mat-checkbox>
                        <span>
                          <small>
                            {{sensor.totalSelected}} {{'COMMON.OF' | translate}} {{sensor.total}}
                          </small>
                        </span>
                      </div>
                      <div class="py-2 border-top w-100 d-flex">
                        @for (signal of sensor.signalsList; track $index;) {
                          <div class="signal-item">
                            <mat-checkbox [checked]="signal.checked" (change)="selectSignal($event, signal, sensor, metmast)">
                              <span [appCustomTooltip]="tooltipTemplate">{{signal.displayName }}
                              </span>
                            </mat-checkbox>
                            <ng-template #tooltipTemplate>
                              <div>
                                <b>{{signal.displayName }}</b><br>
                                {{signal.dbName}}
                              </div>
                            </ng-template>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </ng-template>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        }
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</div>